import React from 'react';
import { Box, BoxProps, Flex, FlexProps, StackProps } from '@chakra-ui/react';
import { motion, MotionProps } from 'framer-motion';

export const MotionBox = motion<BoxProps & MotionProps>(Box, { forwardMotionProps: true });
export const MotionFlex = motion<FlexProps & MotionProps>(Flex, { forwardMotionProps: true });
export const MotionStack = motion<StackProps & MotionProps>(Flex, { forwardMotionProps: true });
